<template>
  <div class="mod-overlay">
    <div class="mod-modal proyecto-modal">
      <!-- Header -->
      <div class="mod-modal-header">
        <h3 class="mod-modal-title">
          <i :class="modoEdicion ? 'bi bi-pencil' : 'bi bi-plus-circle'"></i>
          {{ modoEdicion ? 'Editar proyecto' : 'Nuevo proyecto' }}
        </h3>
        <button class="mod-modal-close" @click="$emit('close')">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <!-- Body -->
      <form @submit.prevent="handleSubmit" class="mod-modal-body">
        <!-- Error -->
        <div v-if="error" class="mod-alert-error">
          <i class="bi bi-exclamation-triangle-fill"></i>
          {{ error }}
        </div>

        <div class="proyecto-tabs">
          <button
            type="button"
            class="proyecto-tab"
            :class="{ 'is-active': tabActiva === 'datos' }"
            @click="tabActiva = 'datos'"
          >
            Datos
          </button>
          <button
            type="button"
            class="proyecto-tab"
            :class="{ 'is-active': tabActiva === 'contactos' }"
            :disabled="!proyectoGuardado"
            title="Guarda el proyecto para agregar contactos"
            @click="tabActiva = 'contactos'"
          >
            Contactos
          </button>
          <button
            type="button"
            class="proyecto-tab"
            :class="{ 'is-active': tabActiva === 'archivos' }"
            :disabled="!proyectoGuardado"
            title="Guarda el proyecto para agregar archivos"
            @click="tabActiva = 'archivos'"
          >
            Archivos
          </button>
        </div>

        <div v-show="tabActiva === 'datos'" class="mod-form-grid">
          <!-- Clave -->
          <div class="mod-field">
            <label for="Clave">Clave <span class="mod-required">*</span></label>
            <input
              type="text"
              id="Clave"
              v-model="form.Clave"
              :disabled="modoEdicion"
              required
              maxlength="50"
              placeholder="Codigo del proyecto"
            >
          </div>

          <!-- Nombre -->
          <div class="mod-field">
            <label for="Nombre">Nombre <span class="mod-required">*</span></label>
            <input
              type="text"
              id="Nombre"
              v-model="form.Nombre"
              required
              placeholder="Nombre del proyecto"
            >
          </div>

          <!-- ClavePadre -->
          <div class="mod-field">
            <label for="ClavePadre">Proyecto padre</label>
            <CatSearch
              id="ClavePadre"
              catalogo="proyecto"
              v-model="form.ClavePadre"
              placeholder="Buscar proyecto padre..."
            />
          </div>

          <!-- Descripcion -->
          <div class="mod-field">
            <label for="Descripcion">Descripcion</label>
            <input
              type="text"
              id="Descripcion"
              v-model="form.Descripcion"
              placeholder="Descripcion del proyecto"
            >
          </div>

          <!-- Socio de Negocio -->
          <div class="mod-field">
            <label for="SocioNegocioClave">Cliente (Clave)</label>
            <CatSearch
              id="SocioNegocioClave"
              catalogo="cliente"
              v-model="form.SocioNegocioClave"
              placeholder="Buscar cliente..."
              @select="onSelectSN"
            />
          </div>

          <!-- SocioNegocioNombre -->
          <div class="mod-field">
            <label for="SocioNegocioNombre">Cliente (Nombre)</label>
            <input
              type="text"
              id="SocioNegocioNombre"
              v-model="form.SocioNegocioNombre"
              placeholder="Nombre del cliente"
            >
          </div>

          <!-- SocioNegocioClaveFiscal -->
          <div class="mod-field">
            <label for="SocioNegocioClaveFiscal">RFC</label>
            <input
              type="text"
              id="SocioNegocioClaveFiscal"
              v-model="form.SocioNegocioClaveFiscal"
              placeholder="RFC del cliente"
            >
          </div>

          <!-- Responsable -->
          <div class="mod-field">
            <label for="Responsable">Responsable</label>
            <input
              type="text"
              id="Responsable"
              v-model="form.Responsable"
              placeholder="Responsable del proyecto"
            >
          </div>

          <!-- Estatus -->
          <div class="mod-field">
            <label for="Estatus">Estatus <span class="mod-required">*</span></label>
            <CatSearch
              id="Estatus"
              catalogo="proyecto_estatus"
              v-model="form.Estatus"
              placeholder="Buscar estatus..."
            />
          </div>

          <!-- FechaInicio -->
          <div class="mod-field">
            <label for="FechaInicio">Fecha inicio</label>
            <input
              type="date"
              id="FechaInicio"
              v-model="form.FechaInicio"
            >
          </div>

          <!-- FechaFin -->
          <div class="mod-field">
            <label for="FechaFin">Fecha fin</label>
            <input
              type="date"
              id="FechaFin"
              v-model="form.FechaFin"
            >
          </div>

          <!-- Presupuesto -->
          <div class="mod-field">
            <label for="Presupuesto">Presupuesto</label>
            <input
              type="number"
              id="Presupuesto"
              v-model.number="form.Presupuesto"
              step="0.01"
              placeholder="0.00"
            >
          </div>

          <!-- CostoActual -->
          <div class="mod-field">
            <label for="CostoActual">Costo actual</label>
            <input
              type="number"
              id="CostoActual"
              v-model.number="form.CostoActual"
              step="0.01"
              placeholder="0.00"
            >
          </div>

          <!-- PorcentajeAvance -->
          <div class="mod-field">
            <label for="PorcentajeAvance">% Avance</label>
            <input
              type="number"
              id="PorcentajeAvance"
              v-model.number="form.PorcentajeAvance"
              step="0.01"
              placeholder="0.00"
            >
          </div>

          <!-- Direccion -->
          <div class="mod-field">
            <label for="Direccion">Direccion</label>
            <input
              type="text"
              id="Direccion"
              v-model="form.Direccion"
              placeholder="Direccion del proyecto"
            >
          </div>

          <!-- Telefono -->
          <div class="mod-field">
            <label for="Telefono">Telefono</label>
            <input
              type="text"
              id="Telefono"
              v-model="form.Telefono"
              placeholder="Telefono de contacto"
            >
          </div>

          <!-- Email -->
          <div class="mod-field">
            <label for="Email">Email</label>
            <input
              type="text"
              id="Email"
              v-model="form.Email"
              placeholder="Correo electronico"
            >
          </div>

          <!-- ClaveErp -->
          <div class="mod-field">
            <label for="ClaveErp">Clave ERP</label>
            <input
              type="text"
              id="ClaveErp"
              v-model="form.ClaveErp"
              placeholder="Mapeo con sistema ERP"
            >
          </div>

          <!-- Notas -->
          <div class="mod-field">
            <label for="Notas">Notas</label>
            <input
              type="text"
              id="Notas"
              v-model="form.Notas"
              placeholder="Notas adicionales"
            >
          </div>

          <!-- EsActivo -->
          <div class="mod-field mod-field-check">
            <label class="mod-check-label">
              <input type="checkbox" v-model="form.EsActivo">
              <span>Activo</span>
            </label>
          </div>
        </div>

        <ProyectoContactosPanel
          v-if="proyectoGuardado && tabActiva === 'contactos'"
          :proyecto-clave="form.Clave"
        />

        <ProyectoArchivosPanel
          v-if="proyectoGuardado && tabActiva === 'archivos'"
          :proyecto-clave="form.Clave"
        />

        <!-- Footer -->
        <div v-show="tabActiva === 'datos'" class="mod-modal-footer">
          <button type="button" class="mod-btn mod-btn-cancel" @click="$emit('close')">
            Cancelar
          </button>
          <button type="submit" class="mod-btn mod-btn-save" :disabled="saving">
            <span v-if="saving" class="mod-spinner-sm"></span>
            <template v-else>
              <i class="bi bi-check-lg"></i>
              {{ modoEdicion ? 'Guardar cambios' : 'Crear proyecto' }}
            </template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import proyectoService from './proyecto.service';
import { showToast } from '@/shared/utils/toast';
import authService from '@/services/auth';
import { createProyecto } from './proyecto.model';
import CatSearch from '@/shared/components/CatSearch.vue';
import ProyectoContactosPanel from './ProyectoContactosPanel.vue';
import ProyectoArchivosPanel from './ProyectoArchivosPanel.vue';

export default {
  name: 'ProyectoForm',
  components: { CatSearch, ProyectoContactosPanel, ProyectoArchivosPanel },
  props: {
    item: { type: Object, default: null },
    isEdit: { type: Boolean, default: false }
  },
  emits: ['saved', 'close'],
  data() {
    return {
      form: createProyecto(),
      modoEdicion: this.isEdit,
      tabActiva: 'datos',
      saving: false,
      error: null
    };
  },
  computed: {
    proyectoGuardado() {
      return this.modoEdicion && !!this.form.Clave;
    }
  },
  created() {
    if (this.isEdit && this.item) {
      this.form = { ...this.item };
      this.modoEdicion = true;
    } else {
      const empresa = authService.getSelectedEmpresa();
      this.form.EmpresaId = empresa?.EmpresaId || 0;
      this.modoEdicion = false;
    }
  },
  methods: {
    onSelectSN(item) {
      this.form.SocioNegocioClave       = item.Clave;
      this.form.SocioNegocioNombre      = item.Nombre;
      this.form.SocioNegocioClaveFiscal = item.Rfc || '';
    },
    async handleSubmit() {
      this.saving = true;
      this.error = null;

      if (!String(this.form.Clave || '').trim() || !String(this.form.Nombre || '').trim()) {
        this.error = 'Clave y Nombre son obligatorios';
        this.saving = false;
        return;
      }

      if (!String(this.form.Estatus || '').trim()) {
        this.error = 'El estatus es obligatorio';
        this.saving = false;
        return;
      }

      try {
        const result = await proyectoService.guardar(this.form);
        if (result.Number >= 0) {
          const eraNuevo = !this.modoEdicion;
          showToast(
            eraNuevo ? 'Proyecto creado. Ya puedes agregar contactos y archivos.' : (result.Message || 'Guardado correctamente'),
            result.Type || 'success'
          );
          if (eraNuevo) {
            this.form = { ...this.form, ...(result.Data || {}) };
            this.modoEdicion = true;
            this.tabActiva = 'contactos';
            this.$emit('saved', { keepOpen: true, item: { ...this.form } });
          } else {
            this.$emit('saved');
          }
        } else {
          this.error = result.Message || 'Error al guardar';
        }
      } catch {
        this.error = 'Error de conexion con el servidor';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";
@import "./proyectoGestionPanels.css";
</style>
